import classNames from 'classnames';
import type { ReactNode } from 'react';
import React, { useEffect } from 'react';

import { Alert } from '@sravni/react-design-system';
import { Icon } from '@sravni/react-design-system/lib/Icon';
import { Text } from '@sravni/react-design-system/lib/Typography';
import { useBoolean } from '@sravni/react-utils';

import { Question } from '@src/components/icons';
import { sendEvent } from '@src/helpers/analyticsEvents';
import { EVENT_CATEGORY } from '@src/helpers/analyticsEvents/constants';

import styles from './MobileAppConvenienceInfoBox.module.scss';
import { MobileAppConvenienceBannerTexts } from './MobileAppConvenienceInfoBox.texts';
import { MobileAppConvenienceSheet } from './MobileAppConvenienceSheet';

interface Props {
  isUserFromGoogleSearch: boolean;
  children: ReactNode;
}

const EVENT_ACTION = 'Оффер Получи Займ|Экран калькулятора|Блок|В приложении удобнее';

export const MobileAppConvenienceInfoBox = ({ isUserFromGoogleSearch, children }: Props) => {
  const [isSheetVisible, setIsSheetVisible] = useBoolean();

  useEffect(() => {
    sendEvent(EVENT_CATEGORY, EVENT_ACTION, 'Показ');
  }, []);

  const handleInfoClick = () => {
    sendEvent(EVENT_CATEGORY, `${EVENT_ACTION}|Инфо`, 'Клик');
    setIsSheetVisible.on();
  };

  return (
    <Alert
      className={classNames(styles.alert, { [styles.blueAlert]: isUserFromGoogleSearch })}
      title={
        <div className={styles.titleContainer}>
          <Text size={14} className={isUserFromGoogleSearch ? styles.googleText : styles.text}>
            {MobileAppConvenienceBannerTexts.title}
          </Text>
          <Icon
            size={16}
            className={classNames(styles.icon, { [styles.greyIcon]: isUserFromGoogleSearch })}
            icon={<Question />}
            onClick={handleInfoClick}
          />
        </div>
      }
    >
      <div>{children}</div>

      <MobileAppConvenienceSheet visible={isSheetVisible} onClose={setIsSheetVisible.off} />
    </Alert>
  );
};
